import React from 'react';
import { connect } from 'react-redux';

import CollectionPrice from '../components/CollectionPrice';
import { variantWithSku } from '../selectors';

const mapStateToProps = (state, props) => {
  let collection = [];

  for (let i = 0; i < props.collectionItems.length; i++) {
    collection.push({
      skuInfo: variantWithSku(props.collectionItems[i].sku, state),
      quantity: props.collectionItems[i].quantity,
    });
  }

  return {
    collection,
  };
};

export default connect(mapStateToProps)(CollectionPrice);



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/containers/CollectionPrice.js